import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

const FileInput = ({
  onChange,
  label,
  accept,
  multiple = false,
  id,
  inputId,
}) => (
  <Button id={id} variant="contained" component="label">
    <Fragment>
      {label}
      <input
        id={inputId}
        accept={accept}
        multiple={multiple}
        onChange={onChange}
        style={{ display: "none" }}
        type="file"
      />
    </Fragment>
  </Button>
);

FileInput.defaultProps = {
  accept: "*",
  label: "Upload",
};

FileInput.propTypes = {
  accept: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  inputId: PropTypes.string,
};

export default FileInput;
